import React, { Component } from 'react';
import { Navbar, Nav, NavItem, NavbarToggler, Collapse } from 'reactstrap';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import firebase from 'firebase/app'

class MenuBar extends Component {
    constructor(props) {
        super(props);
    
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
            user: null
        };
    }

    componentDidMount() {
        this.authUnRegFunc = firebase.auth().onAuthStateChanged(user => {
            if (user) { // user exists so they've logged in
                this.setState(state => {
                    state.user = user;
                    return state;
                });
                this.props.updateUser(user);
            } else {
                this.setState(state => {
                    state.user = null;
                    return state;
                });
                this.props.updateUser(null);
            }
        });
    }

    componentWillUnmount() {
        this.authUnRegFunc.off(); // turn off listener when app closes
    }

    // Toggles whether or not the menu bar is open
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    // Sign in
    signIn() {
        // Sign in Firebase using popup auth and Google as the identity provider.
        var provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider).catch((error) => alert(error));
    }

    // Sign Out
    signOut() {
        firebase.auth().signOut().catch((error) => alert(error));
    }

    render() {
        if (this.state.user !== null) {
            return(
                <div id="app" className="container-fluid">
                    <Navbar id="mainmenu" dark expand="lg" className="change-color" fixed={'top'}>
                        <Link to="/" className="navbar-brand change-color"><span aria-hidden="true" className="logo">&nbsp;</span>GrubRun</Link>
                        <NavbarToggler onClick={this.toggle} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="ml-auto" navbar>
                                <NavItem>
                                    <NavLink to={`/favorites/${this.state.user.uid}`} className="nav-link change-color padding-fix" activeStyle={{fontWeight: "bold"}}>
                                        <i className="fas fa-heart fa-fw"></i>&nbsp; Favorites
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink smooth className="nav-link change-color padding-fix" to="/#features" activeStyle={{fontWeight: "bold"}}>
                                        Features
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink smooth className="nav-link change-color padding-fix" to="/#picker" activeStyle={{fontWeight: "bold"}}>
                                        Start
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink to="/about" className="nav-link change-color padding-fix" activeStyle={{fontWeight: "bold"}}>
                                        About
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink id="login" onClick={this.signOut} to="/" className="nav-link change-color nav-button">
                                        Sign Out
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </Navbar>
                </div>
            );
        } else {
            return(
                <div id="app" className="container-fluid">
                    <Navbar id="mainmenu" dark expand="lg" className="change-color" fixed={'top'}>
                        <Link to="/" className="navbar-brand change-color"><span aria-hidden="true" className="logo">&nbsp;</span>GrubRun</Link>
                        <NavbarToggler onClick={this.toggle} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="ml-auto" navbar>
                                <NavItem>
                                    <NavLink smooth className="nav-link change-color padding-fix" to="/#features" activeStyle={{fontWeight: "bold"}}>
                                        Features
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink smooth className="nav-link change-color padding-fix" to="/#picker" activeStyle={{fontWeight: "bold"}}>
                                        Start
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink to="/about" className="nav-link change-color padding-fix" activeStyle={{fontWeight: "bold"}}>
                                        About
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink id="login" onClick={this.signIn} to="/" className="nav-link change-color nav-button">
                                        Sign In
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </Navbar>
                </div>
            );
        }
    }
}

export default MenuBar;